import React, { useEffect } from 'react';
import Loading from '@components/common/loading';
import useQueryParams from '@hooks/useQueryParams';
import { removeCacheX_tenant, setCacheAccessToken, setCacheIsAdmin } from '@services/userService';

const VerifyPage = () => {
    const { params } = useQueryParams();
    const accessToken = params.get('accessToken');

    useEffect(() => {
        if (accessToken) {
            removeCacheX_tenant();
            setCacheIsAdmin(false);
            setCacheAccessToken(accessToken);

            const timer = setTimeout(() => {
                window.location.href = '/';
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [accessToken]);

    return (
        <Loading show>
        </Loading>
    );
};

export default VerifyPage;
